<template>
  <svg width="13" height="13" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.625 7.75H2.375V17.125H3.625V7.75Z" fill="#0B4DFE" />
    <path d="M3.625 0.875H2.375V5.25H3.625V0.875Z" fill="#0B4DFE" />
    <path d="M8.625 13.375H7.375V17.125H8.625V13.375Z" fill="#0B4DFE" />
    <path d="M8.625 0.875H7.375V10.875H8.625V0.875Z" fill="#0B4DFE" />
    <path d="M13.625 7.75H12.375V17.125H13.625V7.75Z" fill="#0B4DFE" />
    <path d="M13.625 0.875H12.375V5.25H13.625V0.875Z" fill="#0B4DFE" />
    <path d="M5.5 5.875H0.5V7.125H5.5V5.875Z" fill="#0B4DFE" />
    <path d="M15.5 5.875H10.5V7.125H15.5V5.875Z" fill="#0B4DFE" />
    <path d="M10.5 11.5H5.5V12.75H10.5V11.5Z" fill="#0B4DFE" />
  </svg>
</template>

<script>
export default {
  name: 'FilterIcon'
}
</script>

<style scoped>

</style>
